<div #seDateTimePickerDiv class="se-datetime-picker-main-container" [class.se-datetime-no-highlight]="!highlightBackgroundEnabled()">
    <mat-form-field [ngClass]="gridClass() !== '' ? gridClass() : 'se-form-field'"
                    [floatLabel]="isWithLabel() ? 'always' : 'auto'"
                    appearance="{{appearance()}}">
        @if(isWithLabel()){
        <mat-label>{{ label() }}</mat-label>
        }
        <input #dateInput
               matInput
               class="se-form-field-input"
               [class.se-datetime-picker-time-picker-error]="isOnError()"
               autocomplete="off"
               [matDatepicker]="seDateTimePicker_Date"
               [formControl]="dateControl"
               [placeholder]="dateFormat"
               [required]="required()"
               (keydown)="onDateTimeKeydown($event)"
               (dateChange)="onDateChanging($event)" />
        <mat-datepicker-toggle class="se-button-no-ripple" tabindex="-1" [for]="seDateTimePicker_Date" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #seDateTimePicker_Date [panelClass]="customPanelClass()" (click)="onClick($event)"></mat-datepicker>
        @if(isOnError()){
        <mat-error>{{ getErrorMessage() }}</mat-error>
        }
        @if(!isOnError() && showDateFormatOnHint()){
        <mat-hint class="se-datetime-picker-hint">{{getDateFormat()}}</mat-hint>
        }
    </mat-form-field>

    <mat-form-field class="se-datetime-picker-time-picker" [ngClass]="gridClass() !== '' ? gridClass() : 'se-form-field'" style="max-width:120px;" appearance="{{appearance()}}">
        <input matInput #seTimePickerInput se-autofocus
               [matTimepicker]="seTimePickerInput_Time"
               [formControl]="dateControl"
               [placeholder]="timeFormat"
               [required]="required()" />
        <mat-timepicker interval="15min" #seTimePickerInput_Time
                        (opened)="onOpenTime()"
                        (closed)="onCloseTime()"
                        (selected)="onTimeChanging($event)" />
        @if(!disabled() || showIcon()){
        <mat-timepicker-toggle matIconSuffix [for]="seTimePickerInput_Time">
            <mat-icon matTimepickerToggleIcon>keyboard_arrow_down</mat-icon>
        </mat-timepicker-toggle>
        }
    </mat-form-field>
</div>
